import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { format } from 'date-fns';
import { it } from 'date-fns/locale';

//api
import { ElaborationService } from "../../service/elaboration-service"

//components
import { TabMenu } from "primereact/tabmenu";
import ElaborationProject from "./ElaborationProject";
import ElaborationAnalysisFiles from "./ElaborationAnalysisFiles";
import ElaborationKB from "./ElaborationKB";
import ElaborationTemplate from "./ElaborationTemplate";
import ElaborationTasks from "./ElaborationTasks";

const ElaborationDetail = ()=> {
    const { id } = useParams()
    const [elaboration, setElaboration] = useState(null);
    const [projectId,setProjectId] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);


    const items = [
        { label: 'Progetto', icon: 'pi pi-pen-to-square' },
        { label: 'File di Analisi', icon: 'pi pi-file' },
        { label: 'Knowledge Base', icon: 'pi pi-building-columns' },
        { label: 'Template', icon: 'pi pi-folder' },
        { label: 'Task', icon: 'pi pi-list' },
    ];

    // GET per il dettaglio dell'elaborazione
    useEffect(()=>{
        const fetchElaboration = ()=>{
            ElaborationService.getSingleElaboration(
                id,
                (data)=>{
                    if(data && data.id){
                        const formattedElaborations = {
                            ...data,
                            created_at: data.created_at ? format(new Date(data.created_at), 'dd MMMM yyyy HH:mm', { locale: it }) : '',
                            updated_at: data.updated_at ? format(new Date(data.updated_at), 'dd MMMM yyyy HH:mm', { locale: it }) : '',
                            started_at: data.started_at ? format(new Date(data.started_at), 'dd MMMM yyyy HH:mm', { locale: it }) : '',
                            completed_at: data.completed_at ? format(new Date(data.completed_at),'dd MMMM yyyy HH:mm', { locale: it }): ''
                        };
                        setElaboration(formattedElaborations)
                        setProjectId(formattedElaborations.project)
                    } else {
                        const errorMessage = "La risposta non contiene un array valido di elaborazioni.";
                        console.error(errorMessage);
                        setElaboration(null);
                    }
                },
                    (error) => {
                    console.error("Errore durante il recupero dei progetti: ", error);
                    setElaboration(null);                
                }
            )
        }
        fetchElaboration()
    },[id])

    return (
        <div>
            <h1>Gestione Elaborazione</h1>
            <div className="elaborationDetail__Container">
               <div style={{margin: '2rem'}}>
                  <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
                </div>
                {activeIndex === 0 && (
                  <ElaborationProject projectId={projectId} elaboration={elaboration} />
                )}
                {activeIndex === 1 && (
                  <ElaborationAnalysisFiles projectId={projectId} />
                )}
                {activeIndex === 2 && (
                  <ElaborationKB  />
                )}
                {activeIndex === 3 && (
                  <ElaborationTemplate elaboration={elaboration}  />
                )}
                {activeIndex === 4 && (
                  <ElaborationTasks elaboration={elaboration}  />
                )}
            </div>
        </div>
    )
}

export default ElaborationDetail